<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
      timer: null,
      date: [],
      option: {
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            data: [],
            type: "line",
            smooth: false,
            label: {
              show: true,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
    let self = this;
    this.timer = setInterval(function () {
      self.initChart();
    }, 1000);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(arr = this.data) {
      console.log(this.data, "arr");
      if (arr.length > 0) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.date = [];
      for (var i = 0; i < arr.length; i++) {
        this.option.series[0].data[i] = arr[arr.length - 1 - i].Value;
        this.date.push(arr[arr.length - 1 - i].Name);
      }
      this.option.xAxis.data = this.date;
      if (!this.$store.state.isMB) {
        this.option.grid = {
          top: "8%",
          left: "1%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        };
      }
      this.chart = echarts.init(this.$el, "macarons");
      var _this = this;
      window.addEventListener("resize", function () {
        if (_this.chart) _this.chart.resize();
      });
      this.chart.setOption(this.option);
    },
  },
};
</script>
<style lang="scss">
.chart {
  @media screen and (max-width: 480px) {
    margin-top: -30px;
  }
}
</style>